import type { Ritual } from "@akhshy/types";
import { RitualEntry } from "../molecules/RitualEntry.tsx";
import { Spinner } from "../atoms/Spinner.tsx";
import { LoadMore } from "../atoms/LoadMore.tsx";
import { usePaginated } from "../../lib/usePaginated.ts";
import { client } from "../../lib/api.ts";
import { FALLBACK_RITUALS } from "../../lib/fallback.ts";

export function RitualList() {
  const { items, loading, hasMore, total, loadMore } = usePaginated<Ritual>(
    (page) => client.rituals.list({ page, pageSize: 5 }),
    [],
    FALLBACK_RITUALS.slice(0, 5),
  );

  if (loading && items.length === 0) {
    return <Spinner label="flipping through the notebook" />;
  }
  return (
    <>
      <div className="ritual-list">
        {items.map((r) => (
          <RitualEntry key={r.id} ritual={r} />
        ))}
      </div>
      <LoadMore
        hasMore={hasMore}
        loading={loading}
        total={total}
        count={items.length}
        onClick={loadMore}
      />
    </>
  );
}
